module.exports = __webpack_public_path__ + "img/group.982d5409.svg";